import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionIdiomasDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionIdiomasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionIdiomasService(): Observable<BodyListResponse<EstadoRevisionIdiomasDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionIdiomasDTO>>(API_URL + '/api/v1/estadoRevisionIdiomas/todos');
  }

  guardarEstadoRevisionIdiomasService(estadoRevisionIdiomasDTO: EstadoRevisionIdiomasDTO): Observable<EstadoRevisionIdiomasDTO> {
    return this.http.post<EstadoRevisionIdiomasDTO>(API_URL + '/api/v1/estadoRevisionIdiomas', estadoRevisionIdiomasDTO);
  }

  getEstadoRevisionIdiomasPorCodigoRevisionIdiomasService(codigoRevisionIdiomas: string): Observable<BodyResponse<EstadoRevisionIdiomasDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionIdiomasDTO>>(API_URL + '/api/v1/estadoRevisionIdiomas/' + codigoRevisionIdiomas);
  }

  getEstadoRevisionIdiomasPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionIdiomasDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionIdiomasDTO>>(API_URL + '/api/v1/estadoRevisionIdiomas/persona/' + codigoPersona);
  }
}
